export default "__VITE_ASSET__DcQpAiMD__"